module.exports = __webpack_public_path__ + "img/sopa-letras.c16e5dfb.svg";